import axios from "axios";
import { STATUSES } from "./apiStaus";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const dashboard = createAsyncThunk(
  "dashboard/fetch",
  async (_, { rejectWithValue, serializeError }) => {
    try {
      const response = await axios.get("/meonsupport/support");
      // console.log("response", response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(dashboard.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(dashboard.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(dashboard.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default dashboardSlice.reducer;
